/*
 * Copyright (c) Nexign, JSC, 2020-2021.
 */
/**
 * Styled for wizard confirmation step
 *
 * @author Aleksandr Perkhunov
 * @author Yakov Gushchin
 * @version 1.14.0
 * @since 1.10.0
 */

import styled from 'styled-components';

import { LinkContainerStyled } from '../../../../components/common/LinkBlock/styled/LinkStyled';
import { colors, fonts } from '../../../../theme';

export const WizardStepConfirmationStyled = styled.div`
    display: flex;
    justify-content: space-between;
    margin-top: 32px;

    > div:first-child {
        flex: 1 0 0;
        padding-right: 32px;
    }
`;

export const WizardStepConfirmationOnlineCheckTitleStyled = styled.div`
    ${fonts.textMainBold}
`;

export const WizardStepConfirmationRightAreaStyled = styled.div`
    width: 356px;
`;

export const WizardStepConfirmationReportStyled = styled.div`
    margin-top: 24px;
    padding: 24px;
    border: 1px solid ${colors.borderColorLight};
    border-radius: 8px;
`;

export const WizardStepConfirmationRemovedItemStyled = styled.div`
    position: absolute;
    z-index: 1;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(255, 255, 255, 0.95);
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;

    > span:first-child {
        flex: 1;
        text-align: center;
    }

    ${LinkContainerStyled} {
        margin-left: 8px;
    }
`;
